import * as React from 'react';
import EDTooltip from '../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import { PlaceholderCell } from './PlaceholderCell';

interface IPlaneringTooltipCellProps {
  tooltip: string;
  value: string | null;
  placeholder: string;
  isRequiredMissing?: boolean;
  hasWarning?: boolean;
  redDay?: boolean;
}

const PlaneringTooltipCell: React.FC<IPlaneringTooltipCellProps> = ({
  tooltip,
  value,
  placeholder,
  isRequiredMissing = false,
  hasWarning = false,
  redDay = false,
}) => (
  <EDTooltip title={tooltip}>
    <EDBox
      sx={theme => ({
        color: isRequiredMissing
          ? theme.palette.error.main
          : hasWarning
          ? theme.palette.warning.main
          : redDay
          ? theme.palette.error.main
          : 'inherit',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
      })}
    >
      <PlaceholderCell value={value} placeholder={placeholder} />
    </EDBox>
  </EDTooltip>
);

export { PlaneringTooltipCell };
